import axios from "axios";
import jwt_decode from "jwt-decode";
import { logout } from "../helpers/utils";

let isLoggingOut = false;

export const setupAxios = () => {
  // Request interceptor: check token expiration before sending request
  axios.interceptors.request.use(
    (config) => {
      const token = window.localStorage.getItem("eventsafeguardtoken");
      if (token) {
        try {
          const decoded = jwt_decode(token);
          if (decoded && decoded.exp && Date.now() >= decoded.exp * 1000) {
            if (!isLoggingOut) {
              isLoggingOut = true;
              logout();
            }
            return new Promise(() => {});
          }
        } catch (e) {
          if (!isLoggingOut) {
            isLoggingOut = true;
            logout();
          }
          return new Promise(() => {});
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor: catch 401 or jwt expired errors globally
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error && error.response) {
        const status = error.response.status;
        const data = error.response.data;
        const message =
          typeof data === "string"
            ? data
            : (data && data.message ? String(data.message) : "");

        const lowerMsg = message.toLowerCase();
        const isAuthError =
          status === 401 ||
          (status === 403 && lowerMsg.includes("unauthorized")) ||
          lowerMsg.includes("jwt expired") ||
          lowerMsg.includes("token not valid") ||
          lowerMsg.includes("unauthorized");

        if (isAuthError) {
          if (!isLoggingOut) {
            isLoggingOut = true;
            logout();
          }
          // Return a pending promise so component .catch() toast does not appear during redirect
          return new Promise(() => {});
        }
      }
      return Promise.reject(error);
    }
  );
};
